import React from 'react'

import { Button } from '@fourthwall/components'

import type { Plan } from '../../AddSubscriptionModal.types'
import { PlanOption } from '../PlanOption/PlanOption'
import { TermsFooter } from '../TermsFooter/TermsFooter'
import * as S from './SelectPlanStage.styled'

export type SelectPlanStageProps = {
  plans: Plan[]
  selectedPlanId: string
  onPlanSelect: (planId: string) => void
  onContinue: () => void
}

export const SelectPlanStage = ({
  plans,
  selectedPlanId,
  onPlanSelect,
  onContinue,
}: SelectPlanStageProps) => {
  return (
    <>
      <S.Content>
        <S.Description>You can cancel at any time</S.Description>
        <S.PlanOptionsContainer>
          {plans.map((plan) => (
            <PlanOption
              key={plan.id}
              plan={plan}
              selected={plan.id === selectedPlanId}
              onClick={() => onPlanSelect(plan.id)}
            />
          ))}
        </S.PlanOptionsContainer>
      </S.Content>
      <Button label="Continue" appearance="primary" fullWidth onClick={onContinue} />
      <TermsFooter />
    </>
  )
}
